import React from 'react';

const Logo = props => {
  const { white } = props;
  return (
    <div className="flex align-items-center">
      {white ? (
        <img alt="Current" src={require('../images/current-logo-white.png')} width={40} />
      ) : (
        <img alt="Current" src={require('../images/current-logo.png')} width={100} />
      )}
    </div>
  );
};

export default Logo;
